import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FormValidatorService } from 'src/app/shared/services/form-validator.service';
import { BillGetLimits, BillUpdateLimits } from './bill-limits.service';
import { Validators } from 'src/app/shared/validators';

@Component({
  selector: 'app-bill-limits',
  templateUrl: './bill-limits.component.html',
  styleUrls: ['./bill-limits.component.scss'],
})
export class BillLimitsComponent implements OnInit {
  formValidator = new FormValidatorService();
  formGroup!: FormGroup;

  constructor(
    private billGetLimits: BillGetLimits,
    private billUpdateLimits: BillUpdateLimits
  ) {}

  async ngOnInit() {
    this.createFormValidators();
    const res = await this.billGetLimits.make();
    this.setFormValues(res);
  }

  async submit() {
    try {
      if (this.formGroup.invalid) {
        this.formValidator.forceShowErrors();
        return;
      }
      const formData = this.formGroup.value;
      this.billUpdateLimits.setParams(formData);
      await this.billUpdateLimits.make();
    } catch (error) {
      console.log(error);
    }
  }

  getFormControl(name: string): FormControl {
    return this.formGroup.get(name) as FormControl;
  }

  private createFormValidators() {
    this.formGroup = this.formValidator.createForm([
      {
        fieldName: 'daliyLimit',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: 'Required',
          },
          {
            validatorFn: Validators.min(1),
            message: 'Min Value Is 1',
          },
        ],
      },
      {
        fieldName: 'amountLimit',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: 'Required',
          },
          {
            validatorFn: Validators.min(1),
            message: 'Min Value Is 1',
          },
        ],
      },
    ]);
  }

  private setFormValues(data: any) {
    this.formGroup.controls['daliyLimit'].setValue(data.daliyLimit);
    this.formGroup.controls['amountLimit'].setValue(data.amountLimit);
  }
}
